var _circle, _g, _defs;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUploadIcon = function SvgUploadIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#ECEFF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_551_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8441 30.4147C49.9071 30.0297 49.9491 29.6377 49.9491 29.2387C49.9491 25.2067 46.6801 21.9307 42.6411 21.9307C42.6061 21.9307 42.5641 21.9377 42.5291 21.9377C40.6671 18.4167 36.9711 16.0157 32.7151 16.0157C26.5901 16.0157 21.6201 20.9857 21.6201 27.1107C21.6201 27.3487 21.6411 27.5867 21.6551 27.8177C18.8481 28.8397 16.8391 31.5277 16.8391 34.6847C16.8391 38.7167 20.1081 41.9928 24.1471 41.9928H46.5191C49.9841 41.9928 52.7841 39.1857 52.7841 35.7277C52.7911 33.4807 51.6081 31.5207 49.8441 30.4147Z",
    fill: "#9A88EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.147 41.9927H46.519C49.984 41.9927 52.784 39.1857 52.784 35.7277C52.784 33.4877 51.608 31.5277 49.837 30.4217C49.9 30.0367 49.942 29.6447 49.942 29.2457C49.942 25.2137 46.673 21.9377 42.634 21.9377C42.599 21.9377 42.557 21.9447 42.522 21.9447C42.522 21.9377 42.515 21.9377 42.515 21.9307L22.614 41.8247C23.104 41.9297 23.622 41.9927 24.147 41.9927Z",
    fill: "#5943C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1092 48.5937L34.8152 42.8677L27.5142 48.5937H29.5932V54.5997H40.0372V48.5937H42.1092Z",
    fill: "#FDAD34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_551_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.952,
    height: 38.584,
    fill: "white",
    transform: "translate(16.8391 16.0157)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-icon.96ae32cb.svg";
export { ForwardRef as ReactComponent };